import { TextField } from "@adobe/react-spectrum";
import { useSelector } from "react-redux";
import { RootState } from "../../../../state/store";
import { useCallback, useEffect, useState } from "react";
import { useDebounce } from "@uidotdev/usehooks";

interface IFilterSearchTextBoxProps {
    onSearchChange: (params: {}) => void;
    filterParams: any;
    serachedText?: string;
    filterKey?: string;
    placeholder?: string;
    ariaLabel?: string;
}
const FilterSearchTextBox: React.FC<IFilterSearchTextBoxProps> = ({
  onSearchChange,
  filterParams,
  serachedText,
  filterKey = 'contains',
  placeholder,
  ariaLabel = 'Search'
}) => {
  const selectedApp = useSelector((state: RootState) => state.userWebLayout.selectedAppId);
  const [filterTerm, setFilterTerm] = useState<string>(serachedText ?? '');
  const debouncedFilterTerm = useDebounce(filterTerm, 1000);

  const searchServiceActivities = useCallback(async () => {
    if (!filterParams.FILTER.COL.some((obj: any) => obj.name === filterKey) && debouncedFilterTerm === '') {
      return;
    }

    const updatedArray = filterParams.FILTER.COL.map((obj: any) => (obj.name === filterKey ? { ...obj, value: debouncedFilterTerm } : obj));

    const hasNameSearch = filterParams.FILTER.COL.some((obj: any) => obj.name === filterKey);

    if (!hasNameSearch && debouncedFilterTerm) {
      updatedArray.push({
        name: filterKey,
        value: debouncedFilterTerm,
      });
    }

    filterParams.FILTER.COL = updatedArray;
    filterParams.FILTER.COL = filterParams.FILTER.COL.filter((col: any) => col.value !== '');
    onSearchChange(filterParams);
  }, [debouncedFilterTerm, filterKey, filterParams, onSearchChange]);

  useEffect(() => {
    void searchServiceActivities();
  }, [searchServiceActivities]);

  useEffect(() => {
    setFilterTerm('');
  }, [selectedApp]);

  const handleFiltering = async (e: any) => {
    setFilterTerm(e);
  };

  return <TextField value={filterTerm} width={'100%'} onChange={handleFiltering} aria-label={ariaLabel} placeholder={placeholder} />;
};

export default FilterSearchTextBox;
